const removeDuplicatesAndSort = array => [...new Set(array)].sort();

/**
 * Compare two arrays to find out if their contents are the same
 *
 * @param {Array} arr1 - First array to compare
 * @param {Array} arr2 - Second array to compare
 * @param {object} [options] - Options
 * @param {boolean} [options.ignoreOrder] - Enable this to
 * treat arrays that contain the same values in a different order
 * as equal. Will also ignore duplicate entries.
 * @returns {boolean} - Whether or not the passed-in arrays are equal
 */

function areArraysEqual(arr1, arr2, {ignoreOrder = false} = {}) {
	const array1 = ignoreOrder ? removeDuplicatesAndSort(arr1) : arr1;
	const array2 = ignoreOrder ? removeDuplicatesAndSort(arr2) : arr2;

	return (
		array1.length === array2.length &&
		array1.every((element, index) => element === array2[index])
	);
}

export default areArraysEqual;
